import $ from 'jquery';

export const cleanHtmlQuote = () => {
  $('#input-add-quote').html('');
  $('#editor-sidebar-quotes').show();
  $('#select-categories-container').show();
  $('#input-filter-quotes').parent().show();
};
